import { isInViewport } from './modules/util.js';
import { trackLumberjackAndSegment, isMobile } from './segment/segment-utils';
import splitzSetup from './splitz-setup.js';
import { getLjEventProps } from './getLjEventProps';
import lj from './lumberjack';

lj.setupLJ();
let ljproperties = getLjEventProps();

const xPageDataMap = {
  stage_exp_id: 'IgY61pvYrlpR2a',
  prod_exp_id: 'IgYZHfoLTSPOqy',
  default_variant: 'x_lp_sticky_cta_disabled',
  experiment_variable: 'x_lp_sticky_cta_enabled'
};

const payoutsPageDataMap = {
  stage_exp_id: 'IgY7lrhE05D48I',
  prod_exp_id: 'IgYabYxw0cWaZG',
  default_variant: 'x_payouts_sticky_cta_disabled',
  experiment_variable: 'x_payouts_sticky_cta_enabled'
};

const vendorPaymentsPageDataMap = {
  stage_exp_id: 'IgY9RXoKZqDABK',
  prod_exp_id: 'IgYbglE1Gp41Da',
  default_variant: 'x_vp_sticky_cta_disabled',
  experiment_variable: 'x_vp_sticky_cta_enabled'
};

const payoutLinksPageDataMap = {
  stage_exp_id: 'IgYAwssEu4NxLY',
  prod_exp_id: 'IgYcWtzP5HoIbY',
  default_variant: 'x_pl_sticky_cta_disabled',
  experiment_variable: 'x_pl_sticky_cta_enabled'
};

const taxPaymentsPageDataMap = {
  stage_exp_id: 'IgYCrZ08oEmYEM',
  prod_exp_id: 'IgYdJQvvQpVAqN',
  default_variant: 'x_tp_sticky_cta_disabled',
  experiment_variable: 'x_tp_sticky_cta_enabled'
};

const xPageSectionsList = [
  '#headings',
  '#trusted-by',
  '.screen3',
  '#pricing-plan .plan-list',
  '.business-priority-section',
  '#faqs',
  '.screen_9',
  'footer'
];

const payoutsPageSectionsList = [
  '.banner--section',
  '#trusted-by',
  '.payout-capabilities-block',
  '.x-demo-block',
  '#pricing-plan .plan-list',
  '#faqs',
  '.screen_9',
  'footer'
];

const vendorPaymentsPageSectionsList = [
  '#banner-vp',
  '#pricing-plan .plan-list',
  '#faqs-section',
  '.experience-future-of-banking'
];

const payoutLinksPageSectionsList = [
  '.hero',
  '#pricing-plan .plan-list',
  '#accounting-tools',
  '.testimonials-section',
  '.faq',
  '.experience-future-of-banking'
];

const taxPaymentsPageSectionsList = [
  '.standard-hero-section',
  '#pricing-plan .plan-list',
  '.business-priority-section',
  '#faqs',
  'footer'
];

const canHideSignUpBannerInCurrentPage = pageSectionList => {
  let canHideBanner = false;
  for (
    let sectionIndex = 0;
    sectionIndex < pageSectionList.length;
    sectionIndex++
  ) {
    const pageSection = pageSectionList[sectionIndex];
    if (isInViewport(pageSection)) {
      canHideBanner = true;
      break;
    }
  }
  return canHideBanner;
};

function evaluateExpVariables(resp, EXPERIMENT_DATA) {
  if (resp === EXPERIMENT_DATA['default_variant'] || !resp.variables) {
    return false;
  }
  const element = resp.variables.find(
    element => element.key === EXPERIMENT_DATA['experiment_variable']
  );
  return element.value;
}

function renderStickyCta(splitzData, pageDataMap, pageSectionList) {
  const signUpPrompt = $('.signup-prompt');
  let signupBannerImpressionRecorded = false;
  splitzSetup
    .getVariant(
      splitzData.id,
      splitzData.apiBaseUrl,
      splitzData.apiBaseUrl === 'https://api.razorpay.com'
        ? pageDataMap['prod_exp_id']
        : pageDataMap['stage_exp_id'],
      pageDataMap['default_variant']
    )
    .then(resp => {
      if (evaluateExpVariables(resp, pageDataMap)) {
        let signupBannerEligibleSectionShown = false;
        //handle sticky cta signup clicked event
        $('.signup-prompt-button').on('click', e => {
          trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Sticky CTA');
        });

        $(document).on('scroll', e => {
          //handle sticky cta section viewed event
          if (
            !signupBannerEligibleSectionShown &&
            !canHideSignUpBannerInCurrentPage(pageSectionList)
          ) {
            trackLumberjackAndSegment(e, 'Sticky_CTA_section', '');
            signupBannerEligibleSectionShown = true;
          }

          //handle rendering of sticky cta banner
          if (canHideSignUpBannerInCurrentPage(pageSectionList)) {
            signUpPrompt.removeClass('static-signup-prompt');
            signUpPrompt.addClass('hide');
          } else {
            signUpPrompt.addClass('static-signup-prompt');
            signUpPrompt.removeClass('hide');
            if (!signupBannerImpressionRecorded) {
              trackLumberjackAndSegment(e, 'Sticky_CTA', '');
              signupBannerImpressionRecorded = true;
            }
          }
        });
        lj.pushEvents({
          event_name: 'Sticky_CTA_lp',
          event_type: 'viewed',
          properties: {
            version: 'variation',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm,
            device_type: isMobile() ? 'mweb' : 'dweb'
          }
        });
      } else {
        signUpPrompt.addClass('hide');
        lj.pushEvents({
          event_name: 'Sticky_CTA_lp',
          event_type: 'viewed',
          properties: {
            version: 'control',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm,
            device_type: isMobile() ? 'mweb' : 'dweb'
          }
        });
      }
    });
}

$(document).ready(function() {
  let splitzData = splitzSetup.init();
  let currentPage = location.pathname;
  switch (currentPage) {
    case '/x/':
      renderStickyCta(splitzData, xPageDataMap, xPageSectionsList);
      break;
    case '/x/payouts/':
      renderStickyCta(splitzData, payoutsPageDataMap, payoutsPageSectionsList);
      break;
    case '/x/vendor-payments/':
      renderStickyCta(
        splitzData,
        vendorPaymentsPageDataMap,
        vendorPaymentsPageSectionsList
      );
      break;
    case '/x/payout-links/':
      renderStickyCta(
        splitzData,
        payoutLinksPageDataMap,
        payoutLinksPageSectionsList
      );
      break;
    case '/x/tax-payments/':
      renderStickyCta(
        splitzData,
        taxPaymentsPageDataMap,
        taxPaymentsPageSectionsList
      );
      break;
  }
});
